import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { SHOW_SUBMISSION_ERROR_DIALOG } from "submission/submissionActions";
import { getSubmissionErrorDialogVisible } from "common/selectors";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import { useTranslation } from "react-i18next";

import IntlDialogActions from "../../general-components/IntlDialogActions";

const SubmissionErrorDialog = () => {
  const { t } = useTranslation();

  const visible = useSelector(getSubmissionErrorDialogVisible);

  const dispatch = useDispatch();
  const onCancel = () =>
    dispatch({ type: SHOW_SUBMISSION_ERROR_DIALOG, show: false });

  return (
    <Dialog
      open={visible}
      onClose={onCancel}
      aria-labelledby="submission-error-dialog-title"
      aria-describedby="submission-error-dialog-description"
    >
      <DialogTitle id="submission-error-dialog-title">
        {t("submission_error_title")}
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          color="primary"
          id="submission-error-dialog-description"
        >
          {t("submission_error_message")}
        </DialogContentText>
      </DialogContent>

      <IntlDialogActions>
        <Button color="primary" onClick={onCancel}>
          {t("submission_error_ok")}
        </Button>
      </IntlDialogActions>
    </Dialog>
  );
};

export default SubmissionErrorDialog;
